import { DestroyRef, inject, Injectable } from '@angular/core';
import { from, map } from 'rxjs';
import {
  AdminShareHorseData,
  BatchShareHorsesData,
  CreateHorseShareData,
  HorseShareClass,
  HorseShareUpdate,
  ShareItem,
} from '@sleipai/sleip-models';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { doc, docSnapshots, Firestore } from '@angular/fire/firestore';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class HorseShareService {
  constructor() {}

  private firestore = inject(Firestore);
  private functions = inject(Functions);
  private destroyRef = inject(DestroyRef);

  getHorseShareInfo(groupId: string, horseId: string, userId?: string) {
    return docSnapshots(
      doc(this.firestore, `groups/${groupId}/sharedHorses/${horseId}`)
    ).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((horseShareSnap) => {
        const sharedList = horseShareSnap.data()?.['shared'] as ShareItem[];
        const filteredSharedList = sharedList?.filter(
          (shareItem) =>
            shareItem.sharedBy.name !== 'Group-auto-share' &&
            shareItem.client.id !== userId
        );
        return {
          ...horseShareSnap.data(),
          shared: filteredSharedList,
        };
      }),
      map((horseShareObj) => {
        return new HorseShareClass(horseShareObj);
      })
    );
  }

  createHorseShare(horseShareData: CreateHorseShareData) {
    const horseToCreateCallable = httpsCallable(
      this.functions,
      'horsesApi-shareHorse'
    );
    return from(horseToCreateCallable(horseShareData)).pipe(
      map((data) => data.data)
    );
  }


  adminCreateHorseShare(adminShareHorseData: AdminShareHorseData) {
    const adminShareHorseCallable = httpsCallable(
      this.functions,
      'horsesApi-adminShareHorse'
    );
    return from(adminShareHorseCallable(adminShareHorseData)).pipe(
      map((data) => data.data)
    );
  }

  stopHorseShare(horseShareUpdateData: HorseShareUpdate) {
    const horseStopSharingCallable = httpsCallable(
      this.functions,
      'horsesApi-stopShareHorse'
    );
    return from(horseStopSharingCallable(horseShareUpdateData)).pipe(
      map((data) => data.data)
    );
  }

  batchShareHorses(payload: BatchShareHorsesData) {
    const callable = httpsCallable(this.functions, 'horsesApi-batchShareHorses');
    return from(callable(payload)).pipe(map((data) => data.data));
  }

  reactivateHorseShare(horseShareUpdateData: HorseShareUpdate) {
    const horseShareReactivateCallable = httpsCallable(
      this.functions,
      'horsesApi-reactivateInvite'
    );
    return from(horseShareReactivateCallable(horseShareUpdateData)).pipe(
      map((data) => data.data)
    );
  }
}
